import React, { useEffect, useRef } from 'react'
import { TrackerProps } from './types'
import { useTracker } from './contenxt'
import usePageTracker from './usePageTracker'
/**
 *  埋点组件
 * @author: 塔姆
 * @date: 2021/11/10 10:55
 **/
const InternalTracker = (props: TrackerProps) => {
  const trackerRef = useRef<HTMLElement>()
  const tracker = useTracker()
  const observerExposureRef = useRef<IntersectionObserver>()
  const propsRef = useRef(props)
  propsRef.current = props
  // 是否监听page路由
  const trackerPage = props.mode?.includes('page')
  usePageTracker({
    page_jump: trackerPage,
    page_out: trackerPage,
    data: props.data
  })

  useEffect(() => {
    const { mode, data } = propsRef.current
    const trackerDom = trackerRef.current
    if(!trackerDom) {
      return
    }
    const clickEventHandler = () => {
      tracker.onElementClick?.(data)
    }
    if (mode.includes('view')) {
      const _observerExposure = new IntersectionObserver(([ele]: IntersectionObserverEntry[]) => {
        if (ele.isIntersecting) {
          tracker.onElementView?.(data)
        }
      })
      _observerExposure.observe(trackerDom)
      observerExposureRef.current = _observerExposure
    }
    if(mode.includes('hit')) {
      trackerDom.addEventListener('click', clickEventHandler)
    }
    return () => {
      observerExposureRef.current?.disconnect()
      trackerDom?.removeEventListener('click', clickEventHandler)
    }
  }, [tracker])

  const child = React.Children.only(props.children)

  // 如果只包含page, 则直接返回 child
  if(props.mode?.length === 1 && trackerPage) {
    return child
  }

  return React.cloneElement(child, {ref: trackerRef })
}
export default InternalTracker
